var _rect, _path, _path2, _path3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTooltip = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "16 0 64 89"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 52,
  x: 16,
  y: 16,
  fill: "#1D1D1B",
  rx: 4,
  shapeRendering: "crispEdges"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M42.15 43.18h1.53v4.06h-1.53V50h11.83v-2.76h-7.2v-4.06h4.25V40.9h-4.25v-2.3c0-1.78 1.13-2.83 2.66-2.83.99 0 1.97.45 2.52 1.25l2.38-1.85a6.32 6.32 0 0 0-5.02-2.21c-3.29 0-5.64 2.16-5.64 5.57v2.37h-1.53z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A48",
  d: "m43.5 67.5 4.5 4 4.5-4"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#1D1D1B",
  d: "m48 71-4.5-4h9z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 51,
  x: 16.5,
  y: 16.5,
  stroke: "#4A4A48",
  rx: 3.5,
  shapeRendering: "crispEdges"
})));
export { SvgTooltip as ReactComponent };
export default new URL("/home/runner/_work/motorway-seller-webapp/motorway-seller-webapp/src/client/assets_seller/ulez/chart/tooltip.svg", import.meta.url).toString();